module.exports = __webpack_public_path__ + "static/media/mountains.1ee7d773.png";